'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'file-spreadsheet';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'f65b';
var svgPathData = 'M0 64C0 28.7 28.7 0 64 0L213.5 0c17 0 33.3 6.7 45.3 18.7L365.3 125.3c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm208-5.5l0 93.5c0 13.3 10.7 24 24 24L325.5 176 208 58.5zM104 228c-19.9 0-36 16.1-36 36l0 144c0 19.9 16.1 36 36 36l176 0c19.9 0 36-16.1 36-36l0-144c0-19.9-16.1-36-36-36l-176 0zm4 176l0-48 64 0 0 48-64 0zm104 0l0-48 64 0 0 48-64 0zm0-88l0-48 64 0 0 48-64 0zm-40-48l0 48-64 0 0-48 64 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFileSpreadsheet = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;